var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-justify-between tw-p-4"},[_c('div',[_c('RouterLink',{attrs:{"to":"/"}},[_c('img',{staticClass:"tw-w-auto tw-h-6",attrs:{"src":require('@/assets/byfeet-logo.svg')}})])],1),_c('div',[_c('div',{staticClass:"tw-flex tw-items-center tw-space-x-6"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }